<template>
  <b-card style="width: 100%" no-body class="border-0 resource-card">
    <b-card-header
      header-tag="header"
      class="py-3 px-4 pointer border-0 resource-edit-collapse"
      role="tab"
      v-b-toggle="`tab-${block.title.trim().toLowerCase().split(' ').join('_')}`"
    >
      <div class="d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <i class="fas fa-sort-down mr-2" />
            <h4 class="m-0" style="display: inline-block">
              <span v-if="block.icon" :class="[block.icon, 'mr-1', 'fa-lg']" />
              {{ block.title }}
            </h4>
            <custom-tooltip
              class="block-rotation ml-2"
              v-if="block.tooltipName && block.tooltipText"
              :name="block.tooltipName"
            >
              {{ $t(block.tooltipText) }}
            </custom-tooltip>
          </div>
        </div>

        <div />
      </div>
    </b-card-header>

    <b-collapse
      :id="`tab-${block.title.trim().toLowerCase().split(' ').join('_')}`"
      role="tabpanel"
      @show="$emit('show')"
    >
      <b-card-body class="p-4 pb-0">
        <loader v-if="loading" />
        <slot name="body" />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'ResourceWrapper',
  middleware: 'auth',
  props: {
    block: {
      type: Object,
      default: null,
      require: true,
    },
    icon: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
};
</script>
